import { useQuery } from "@tanstack/react-query"
import apiRoutes from "../apiRoutes";
import api from "../utils";

export interface CoinBalances {
    success: boolean;
    info: Info;
}

export interface Info {
    crypto: string;
    fiat: string;
}


export const useCoinBalance = (id: number) => {

    const getCoinBalance = async () => {
        const res = await api.post(apiRoutes.getBalances, {
            coin: id
        });
        return res.data
    }
    const { data: balance, ...rest } = useQuery<CoinBalances>({
        queryKey: ["coin_balance", id],
        queryFn: getCoinBalance,
        enabled: !!id

    })
    return {
        balance,
        ...rest
    }
}